import React, { Component } from 'react';
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem, Divider } from 'rc-menu';
import 'rc-dropdown/assets/index.css';

class TipoPlasticoDropdown extends Component {

    constructor(props) {
        super(props);
        const { opciones, seleccionados } = this.props;
        this.state = { visible: false };
    }

    onVisibleChange(visible) {
        this.setState({ visible });
    }

    saveSelected({ selectedKeys }) {
        this.selected = selectedKeys;

        const selectedItems = [];
        for (var i = 0; i < selectedKeys.length; i++) {
            selectedItems.push(this.props.opciones.find(x => x.Id == selectedKeys[i]));
        }

        selectedKeys.map(k => this.props.opciones[parseInt(k, 10)]);
        this.props.selectFn(selectedItems);
    }

    confirm() {
        this.setState({ visible: false });
    }

    render() {

        const { opciones, seleccionados } = this.props;
        const selected = seleccionados.map(s => s.toString());

        const menu = (
            <Menu style={{ width: 140, height: 134 }} multiple onSelect={this.saveSelected.bind(this)} onDeselect={this.saveSelected.bind(this)} defaultSelectedKeys={selected} >
                {opciones.map((opcion, index) => <MenuItem key={opcion.Id}>{opcion.Descripcion}</MenuItem>)}
                <Divider />
                <MenuItem disabled>
                    <button
                        style={{ cursor: 'pointer', color: '#000', pointerEvents: 'visible', marginLeft: 28 }}
                        onClick={this.confirm.bind(this)}
                        className="btn btn-default"
                    >
                        Cerrar
                </button>
                </MenuItem>
            </Menu>
        );

        return (
            <Dropdown
                trigger={['click']}
                onVisibleChange={this.onVisibleChange.bind(this)}
                visible={this.state.visible}
                closeOnSelect={false}
                overlay={menu}
                animation="slide-up"
            >
                <button className="btn btn-default" type="button">
                    Tipo de plástico
            </button>
            </Dropdown>
        );
    }
}

export default TipoPlasticoDropdown;